(() => {
  const initializeCoaLibrary = (root) => {
    if (!root || root.dataset.coaInitialized === 'true') return;
    root.dataset.coaInitialized = 'true';

    const search = root.querySelector('[data-coa-search]');
    const clearButton = root.querySelector('[data-coa-clear]');
    const clearAllButton = root.querySelector('[data-coa-clear-all]');
    const resetButton = root.querySelector('[data-coa-reset]');
    const status = root.querySelector('[data-coa-status]');
    const emptyState = root.querySelector('[data-coa-empty]');
    const cards = [...root.querySelectorAll('[data-coa-card]')];
    const groups = [...root.querySelectorAll('[data-coa-group]')];
    const filters = [...root.querySelectorAll('[data-coa-filter]')];
    let activeCategory = 'all';

    if (!search || !status || !emptyState) return;

    const normalize = (value) =>
      value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

    const categoryCounts = cards.reduce((counts, card) => {
      const category = card.dataset.category;
      counts[category] = (counts[category] || 0) + 1;
      return counts;
    }, {});

    filters.forEach((filter) => {
      const count = filter.querySelector('[data-coa-filter-count]');
      if (!count) return;
      count.textContent =
        filter.dataset.coaFilter === 'all' ? String(cards.length) : String(categoryCounts[filter.dataset.coaFilter] || 0);
    });

    groups.forEach((group) => {
      const count = group.querySelector('[data-coa-group-count]');
      const groupCards = group.querySelectorAll('[data-coa-card]').length;
      if (count) count.textContent = String(groupCards);
      group.hidden = groupCards === 0;
    });

    const update = () => {
      const query = normalize(search.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesCategory = activeCategory === 'all' || card.dataset.category === activeCategory;
        const matchesQuery = !query || normalize(`${card.dataset.title} ${card.dataset.category}`).includes(query);
        const isVisible = matchesCategory && matchesQuery;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      groups.forEach((group) => {
        const hasVisibleCards = [...group.querySelectorAll('[data-coa-card]')].some((card) => !card.hidden);
        group.hidden = !hasVisibleCards;
      });

      clearButton?.classList.toggle('is-visible', search.value.length > 0);
      if (clearAllButton) clearAllButton.hidden = !query && activeCategory === 'all';
      emptyState.hidden = visibleCount !== 0;

      const label = visibleCount === 1 ? 'certificate' : 'certificates';
      const queryContext = query ? ` matching “${search.value.trim()}”` : '';
      const count = document.createElement('strong');
      count.textContent = String(visibleCount);
      status.replaceChildren(document.createTextNode('Showing '), count, document.createTextNode(` ${label}${queryContext}`));
    };

    const reset = () => {
      activeCategory = 'all';
      search.value = '';
      filters.forEach((filter) => {
        const isActive = filter.dataset.coaFilter === 'all';
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });
      update();
      search.focus();
    };

    search.addEventListener('input', update);
    clearButton?.addEventListener('click', () => {
      search.value = '';
      update();
      search.focus();
    });
    clearAllButton?.addEventListener('click', reset);
    resetButton?.addEventListener('click', reset);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.coaFilter;
        filters.forEach((otherFilter) => {
          const isActive = otherFilter.dataset.coaFilter === activeCategory;
          otherFilter.classList.toggle('is-active', isActive);
          otherFilter.setAttribute('aria-pressed', String(isActive));
        });
        update();
      });
    });

    update();
  };

  const initializeAll = (container = document) => {
    container.querySelectorAll('[data-coa-library]').forEach(initializeCoaLibrary);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
